<div *ngIf="form" class="form-container">
    <div class="form-col intro">
        <h1>
            {{ localizations.aumico_users_personal_information_main_title | i18next }}
        </h1>
        <p>
            {{ localizations.aumico_users_personal_information_sub_title | i18next }}
        </p>
    </div>

    <form [formGroup]="form" class="form-fields-margin-top form-container">
        <div class="form-row">
            <div class="form-field">
                <label>
                    {{ localizations.aumico_users_personal_information_organization_label | i18next }}
                </label>
                <input
                    hamInput
                    type="text"
                    [readonly]="form.controls['organizationName'].disabled"
                    [placeholder]="localizations.aumico_reports_input_please_enter_placeholder | i18next"
                    [formControl]="form.controls['organizationName']"
                />
            </div>
        </div>

        <!-- First and Last Name -->
        <div class="form-row">
            <div class="form-field">
                <label>
                    {{ localizations.aumico_reports_registration_welcome_first_name_label | i18next }}
                </label>
                <input
                    hamInput
                    type="text"
                    [placeholder]="localizations.aumico_reports_input_please_enter_placeholder | i18next"
                    [formControl]="form.controls['firstName']"
                />
            </div>

            <div class="form-field">
                <label>
                    {{ localizations.aumico_reports_registration_welcome_last_name_label | i18next }}
                </label>
                <input
                    hamInput
                    type="text"
                    [placeholder]="localizations.aumico_reports_input_please_enter_placeholder | i18next"
                    [formControl]="form.controls['lastName']"
                />
            </div>
        </div>

        <div class="form-row">
            <div class="form-row">
                <input
                    hamSimpleDropDown
                    [options]="languagesSelections"
                    [formControl]="form.controls['locale']"
                    [optionKeys]="['name']"
                    [returnKey]="'id'"
                    [returnObject]="true"
                    [placeholder]="localizations.aumico_users_edit_user_general_information_choose_language | i18next"
                    [label]="localizations.aumico_users_personal_information_language_section_title | i18next"
                />
                <div class="form-error" *ngIf="form.controls['locale']?.invalid && form.controls['locale']?.touched">
                    {{ localizations.aumico_users_personal_information_language_error | i18next }}
                </div>
            </div>
        </div>
    </form>
</div>
